const C = {
  name: "Wallet",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12Z" fill="currentColor"/>
<path d="M22 18V16.8282C23.1632 16.4148 24 15.3019 24 14V10C24 8.69806 23.1632 7.58522 22 7.17183V6C22 4.44943 20.8388 3 19.2 3H4.8C3.16122 3 2 4.44943 2 6V18C2 19.5506 3.16122 21 4.8 21H19.2C20.8388 21 22 19.5506 22 18ZM4.8 5H19.2C19.5412 5 20 5.35057 20 6V7H16C13.2377 7 11 9.23772 11 12C11 14.7623 13.2377 17 16 17H20V18C20 18.6494 19.5412 19 19.2 19H4.8C4.45878 19 4 18.6494 4 18V6C4 5.35057 4.45878 5 4.8 5ZM22 14C22 14.5477 21.5477 15 21 15H16C14.3423 15 13 13.6577 13 12C13 10.3423 14.3423 9 16 9H21C21.5477 9 22 9.45228 22 10V14Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Wallet
};
